import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import * as Sentry from "@sentry/react";
import packageJson from "../package.json";

// SERVICE WORKER
import reportWebVitals from "./reportWebVitals";
import * as serviceWorker from "./serviceWorker";

// TO DELETE
import "./index.css";
import "font-awesome/css/font-awesome.min.css";

// ROUTES
import MainRoutes from "./router/routes";

// ONLY FOR CALENDAR & TABLE
import "./SCSS/app.css";

// CONTRACTS PAGE DATA PROVIDERS
import { FilterContractsProvider } from "./context/filter_contracts_context";
import { ContractsProvider } from "./context/contracts_context";

// CONFIG
import getConfig from "./config";

// COMPONENTS
import ScrollToHashElement from "~/components/ScrollToHashElement";

// PROVIDERS
import { WalletProvider } from "./context/wallet_context";
import Auth0ProviderWithNavigate from "./context/Auth0ProviderWithNavigate";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://99bad8976ab94a918cc852842ef67af4@o4505071164260352.ingest.sentry.io/4505071202926592",
    environment: process.env.NODE_ENV,
    // eg: parcision-frontend@0.1.2
    release: `${packageJson.name}@${packageJson.version}`,
    integrations: [new Sentry.BrowserTracing(), new Sentry.Replay()],
    // Performance Monitoring
    tracesSampleRate: 0.2, // Capture 100% of the transactions, reduce in production!
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}
// Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
// for a full list of the available properties on the provider
const config = getConfig();

const providerConfig = {
  domain: config.domain,
  clientId: config.clientId,
  authorizationParams: {
    redirect_uri: `${window.location.origin}/complete-auth`,
    ...(config.audience ? { audience: config.audience } : null),
  },
};

const root = ReactDOM.createRoot(document.getElementById("root"));

// React18
root.render(
  <BrowserRouter>
    <Auth0ProviderWithNavigate {...providerConfig}>
      <WalletProvider>
        <FilterContractsProvider>
          <ContractsProvider>
            <MainRoutes />
            <ScrollToHashElement />
          </ContractsProvider>
        </FilterContractsProvider>
      </WalletProvider>
    </Auth0ProviderWithNavigate>
  </BrowserRouter>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

reportWebVitals();
